export var DokobitError;
(function (DokobitError) {
    DokobitError["AgeMismatch"] = "age_mismatch_error";
    DokobitError["WaitingForAuthError"] = "money-waiting_for_auth_error";
    DokobitError["NameMismatch"] = "name_mismatch_error";
    DokobitError["NameMismatchCancel"] = "name_mismatch_cancel_error";
    DokobitError["UserIsDeclined"] = "user_is_declined_error";
    DokobitError["DuplicatePersonalCode"] = "duplicate_personal_code_error";
    DokobitError["CountryNotSupported"] = "country_not_supported";
    DokobitError["SessionNotFound"] = "session_not_found_error";
    DokobitError["SessionClosed"] = "session_closed_error";
    DokobitError["Server"] = "server_error";
    DokobitError["Unknown"] = "unknown_error";
    DokobitError["Lockdown"] = "lockdown";
})(DokobitError || (DokobitError = {}));
